import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faEdit, faEllipsis, faCloudDownload, faCloudArrowUp, faThumbsUp, faThumbsDown, faTrash } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";

import { Link, useNavigate } from "react-router-dom";

import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
  changeStatus
} from "../../../controllers/V1/salesAgentControllers";
import { getPage } from "../../../controllers/common";
import ExportPopup from './Export';
import {usePermissions} from "../../../controllers/PermissionContext";
import CollectSettlePopup from "./CollectSettlePopup";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {

  const PERMISSION = usePermissions("salesAgent");

  const [isFilterShow, setFilterShow] = useState(false);
  const handleFilterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [isImportShow, setImportShow] = useState(false);
  const handleImportDrawer = () => setImportShow(!isImportShow);

  const [isImportCollectionShow, setImportCollectionShow] = useState(false);
  const handleImportCollection = () => setImportCollectionShow(!isImportCollectionShow);

  const [isDueAmountPopup, setDueAmountPopup] = useState(false);
  const handleDueAmountPopup = () => setDueAmountPopup(!isDueAmountPopup);

  
  const [addEditPopup, setAddEditPopup] = useState(false);
  const toggleAddEditPopup = () => setAddEditPopup(!addEditPopup);
  const [collectType, setCollectType] =useState('Collect');

  const [edit_data, setEditData] = useState('');

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");


  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'first_name' && {first_name : { $regex: filter?.search, $options: "i" } }),
          ...(filter?.filter_by === 'last_name' && {last_name : { $regex: filter?.search, $options: "i" } }),
          ...(filter?.filter_by === 'email' && {email : filter?.search }),
          ...(filter?.filter_by === 'phone' && {phone : parseInt(filter?.search) }),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFilterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "U-Winn CRM || Sales Agent list";
  }, [currentPage, showRequest, filter, addEditPopup, isDueAmountPopup]);

  useEffect(()=>{
    if(edit_data){
      setAddEditPopup(true);
    }
  },[edit_data]);

  const handleUserTypeChange = async (type='') => {
    try {
      setFilter((pre)=>({
        ...pre,
        'filter_by' : 'users_type',
        'search'    : type || ''
      }))
    } catch (error) {
      
    }
  }

  const handleChangeStatus = async (id, status) => {
    try {
        const param = {
            id : id,
            status : status
        }
        const res = await changeStatus(param);
        if(res?.status === true){
            getList();
        } else{

        }
    } catch (error) {
        
    }
  }
  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Sales agent list"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        handleUserTypeChange("");
                        setShowRequest("");
                        setSkip(0);
                      }}
                    />
                    <Tab
                      label="Active"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setShowRequest("A");
                        setSkip(0);
                        }}
                    />

                    <Tab
                      label="Inactive"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setShowRequest("I");
                        setSkip(0);
                    }}
                    />

                    <Tab
                      label="Deleted"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => {
                        setShowRequest("D");
                        setSkip(0);
                    }}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div" onClick={handleFilterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>

                  {/* <div className="inventory_filter_div" onClick={handleExportDrawer}>
                    <FontAwesomeIcon icon={faCloudDownload} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Export
                    </Link>
                  </div> */}
                  {(PERMISSION?.add === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                    <div onClick={() => navigate('/sales-agent/addeditdata')}>
                      <button type="button" class="btn btn-dark">
                        <span className="request_new_categories">Add New</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellSpacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Agent's Details</th>
                              {/* <th>Phone</th>
                              <th>Email</th> */}
                              <th>Bind With</th>
                              <th>Target Collection Amt.</th>
                              <th>Total Collected Amt.</th>
                              <th>Target Settled Amt.</th>
                              <th>Total Settled Amt.</th>
                              <th>Total Due Amt.</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{SKIP + index + 1}</td>
                                    <td className="admin_user_list_date">
                                      <span>{`${items?.first_name} ${items?.last_name}`}</span> <br/>
                                      <span>{items?.phone || '-'}</span> <br/>
                                      <span>{items?.email || '-'}</span>
                                    </td>
                                    <td className="admin_user_list_date">
                                      {`${items?.bind_with?.users_name} ${items?.bind_with?.last_name}`} <br/>
                                      {`POS No. : ${items?.bind_with?.pos_number}`}
                                    </td>

                                    <td className="admin_user_list_date">{items?.bind_with?.target_collection || 0}</td>
                                    <td className="admin_user_list_date">{items?.total_collection || 0}</td>
                                    <td className="admin_user_list_date">{items?.bind_with?.target_settlement || 0}</td>
                                    <td className="admin_user_list_date">{items?.total_settlement || 0}</td>
                                    <td className="admin_user_list_date">{items?.due_amount || 0}</td>
                                    
                                    <td className="admin_user_list_date">
                                      { items?.status === 'A' && 'Active' }
                                      { items?.status === 'I' && 'Inactive' }
                                      { items?.status === 'D' && 'Delete' }
                                      { items?.status === 'B' && 'Block' }
                                    </td>
                                    
                                    <td>
                                      <Dropdown
                                        overlay={
                                          <Menu>
                                            {(PERMISSION?.edit === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                              <Menu.Item key={`01`} onClick={() => { navigate('/sales-agent/addeditdata',{state : items}) }} >
                                                <FontAwesomeIcon icon={faEdit} /> <span className="show_span">Edit</span>
                                              </Menu.Item>
                                            )}
                                            {(PERMISSION?.change_status === 'Y' || PERMISSION?.fullAccess === 'Y') && (<>
                                            
                                              {items?.status === 'A' && (
                                                  <Menu.Item key={`03`} onClick={() => { handleChangeStatus(items?._id, 'I') }} >
                                                  <FontAwesomeIcon icon={faThumbsDown} /> <span className="show_span">Inactive</span>
                                                  </Menu.Item>
                                              )}
                                              {(items?.status === 'I' || items?.status === 'D') && (
                                                  <Menu.Item key={`02`} onClick={() => { handleChangeStatus(items?._id, 'A') }} >
                                                  <FontAwesomeIcon icon={faThumbsUp} /> <span className="show_span">Active</span>
                                                  </Menu.Item>
                                              )}
                                              {items?.status !== 'D' && (
                                                  <Menu.Item key={`04`} onClick={() => { handleChangeStatus(items?._id, 'D') }} >
                                                      <FontAwesomeIcon icon={faTrash} /> <span className="show_span">Delete</span>
                                                  </Menu.Item>
                                              )}

                                              <Menu.Item key={`05`} onClick={() => { setEditData(items); setCollectType('Collect') }} >
                                                <FontAwesomeIcon icon={faEdit} /> <span className="show_span">Collect</span>
                                              </Menu.Item>
                                            
                                              <Menu.Item key={`06`} onClick={() => { setCollectType('Settle'); setEditData(items) }} >
                                                <FontAwesomeIcon icon={faEdit} /> <span className="show_span">Settle</span>
                                              </Menu.Item>
                                              
                                            </>)}
                                          </Menu>
                                        }
                                        placement="bottomLeft"
                                        arrow
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={10} /> : <tr> 
                                <td colspan="9" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFilterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFilterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='first_name' selected={filter?.filter_by ==='first_name'?true:false}>First Name</option>
                  <option value='last_name' selected={filter?.filter_by ==='last_name'?true:false}>Last Name</option>
                  <option value='phone' selected={filter?.filter_by ==='phone'?true:false}>Mobile</option>
                  <option value='email' selected={filter?.filter_by ==='email'?true:false}>Email</option>
                  
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
      <CollectSettlePopup popUpOpen={addEditPopup} togglePopUp={toggleAddEditPopup} edit_data={edit_data} setEditData={setEditData} type={collectType} />
    </>
  );
}
